import TransitApi from './base'

export default {
  // Catálogo de motivos activos para el desplegable.
  async getActive() {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.get('/pending-reason/list')
      return result.data
    } catch (error) {
      return error.response
    }
  },

  // Crear un motivo nuevo ("poder crear más").
  async create(name) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.post('/pending-reason/add', { name })
      return result
    } catch (error) {
      return error.response
    }
  },

  // ===== Administración del catálogo =====
  async getAll(params = {}) {
    try {
      const Api = TransitApi.getSecureInstance()
      const queryString = TransitApi.getQueryString(params)
      const result = await Api.get(`/pending-reason/all?${queryString}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async save(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const path = params.id
        ? `/pending-reason/details/${params.id}`
        : '/pending-reason/add'
      const result = await Api.post(path, params)
      return result
    } catch (error) {
      return error.response
    }
  },

  async delete(id) {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.delete(`/pending-reason/${id}`)
      return result
    } catch (error) {
      return error.response
    }
  },
}
